module.exports = __webpack_public_path__ + "img/nyc-xrp-meetup-4.b9d2e7f0.png";